var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Background"},[(_vm.userStatus === 'admin')?_c('UserInfo'):_c('GuestForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }